import React from 'react';
import cn from 'classnames';

interface PopoverHeaderProps {
  title: string;
  className?: string
  actions?: React.ReactNode;
}
export const PopoverHeader = ({ title, actions, className }: PopoverHeaderProps) => {
  return (
    <div className={cn(["flex justify-between items-center border-b border-separator p-4", className])}>
      <h3 className="text-sm font-semibold">{title}</h3>
      {actions && <div className="flex items-center">{actions}</div>}
    </div>
  );
}

interface PopoverBodyProps {
  children: React.ReactNode;
}
export const PopoverBody = ({ children }: PopoverBodyProps) => {
  return (
    <div className="text-sm">
      {children}
    </div>
  );
}

export const PopoverFooter = ({ children }: PopoverBodyProps) => {
  return (
    <div className="text-sm border-t border-separator p-4">
      {children}
    </div>
  );
}
